import React from 'react';
import Uganda_s5 from './uganda_s5';
import Uganda_s5_subjects from './uganda_s5_subjects';
const Uganda_s5lat = () => {
  return (
    <div>
      <Uganda_s5 />
    <Uganda_s5_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Latin</h1>
      <h3>Performing arts in the new secondary school curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in PA learning and assessment </li>
      <li>Cross-cutting isues integrated in PA learning and assessment </li>
      <li>Values integrated in PA learning and assessment </li>
      </div>
    </div>
  );
}

export default Uganda_s5lat;